import { CustomFieldsComponent } from './custom-fields.component';
import { CustomFieldsFormComponent } from './form/form.component';

export const CUSTOM_FIELDS_DECLARATIONS: any[] = [
    CustomFieldsComponent,
    CustomFieldsFormComponent,
];
